import styled from 'styled-components'

export const ModalContainer = styled.div`
  .groupfie-container {
    position: relative;
    width: 100%;
    height: 198px; 
    background: #f5f5f5;
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 12px;
  }

  .groupfie-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .groupfie-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px; 
    color: #cfcfcf;
  }

  .batch-name-section {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 10px 8px; 
    font-size: 15px; 
    font-weight: 600;
  }

  .coaches-section {
    display: flex;
    gap: 7px; 
    margin-bottom: 12px;
  }

  .coach-bubble {
    display: flex;
    align-items: center;
    gap: 5px;
    background: #f5f5f5;
    padding: 4px 8px; 
    border-radius: 16px;
    font-size: 13px;
  }

  .status-section {
    display: flex;
    gap: 7px;
    margin-bottom: 12px;
    justify-content: center;
    flex-wrap: wrap;
  }

  .status-bubble {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 4px 8px;
    border-radius: 16px;
    font-weight: 500;
    font-size: 13px;
  }

  .status-success {
    background: #f6ffed;
    border: 1px solid #b7eb8f;
    color: #52c41a;
  }

  .status-error {
    background: #fff2e8;
    border: 1px solid #ffbb96;
    color: #fa8c16;
  }

  .details-section {
    background: #fafafa;
    padding: 12px; 
    border-radius: 6px;
  }

  .detail-row {
    display: flex;
    justify-content: space-between;
    padding: 7px 0;
    border-bottom: 1px solid #f0f0f0;
  }

  .detail-row:last-child {
    border-bottom: none;
  }

  .detail-label {
    font-weight: 500;
    color: #595959;
    font-size: 14px;
  }

  .detail-value {
    font-weight: 600;
    color: #262626;
    font-size: 14px;
  }

  .preview-icon-overlay {
    display: flex; 
    align-items: center;
    gap: 5px;
    position: absolute;
    top: 150px;
  }

  .show-preview-icon .ant-image .ant-image-mask {
    opacity: 1 !important;
  }

  .show-preview-icon .ant-image:hover .ant-image-mask {
    opacity: 1 !important;
  }

`;
